// extracted by mini-css-extract-plugin
export default {"hint":"DealingMethodsSection_hint__7NvMb","exchange-input":"DealingMethodsSection_exchange-input__U3E1X"};